import React from 'react';
import { isString } from 'lodash';

var renderImageNode = function renderImageNode(image) {
  if ( /*#__PURE__*/React.isValidElement(image)) {
    return image;
  }
  if (isString(image)) {
    return /*#__PURE__*/React.createElement("img", {
      width: 268,
      src: image,
      alt: ""
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

export { renderImageNode as default };
